import { BaseController } from '~/utils/base-controller';
import { FastImportService as FastImportServiceModel } from './fast-import.service';

export default class FastImportBlockController extends BaseController {
	/** @type {FastImportServiceModel} */
	FastImportService;

	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} FastImportService
	 */
	constructor(
		$scope,
		$uibModal,
		NodeService,
		Notification,
		$injector,
		FastImportService,
	) {
		super($injector);

		this.$scope = $scope;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.$injector = $injector;

		this.loading = false;
		this.isOpen = false;
		this.FastImportService = FastImportService;
		this.widgetId = '';

		(async () => this.fastImportList())();
	}

	/**
	 * @param {Event} event
	 */
	toggle(event) {
		event.stopPropagation();
		this.isOpen = !this.isOpen;
	}

	refreshSize() {
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}

	async fastImportList(force = false) {
		this.loading = true;

		await this.FastImportService.fetch(force);

		this.$timeout(() => {
			this.loading = false;
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
		});

		return this.FastImportService.fastImports;
	}
}
